import { useCallback } from 'react';

import { useConfigContext } from '@sorare/core/src/contexts/config';
import type { MonetaryAmount } from '@sorare/core/src/lib/monetaryAmount';

export const useCalculateDirectOfferMarketFee = () => {
  const { marketFeePercentagePoints } = useConfigContext();
  return useCallback(
    (monetaryAmount: MonetaryAmount) => {
      const { feesMonetaryAmount } = monetaryAmount.calculateFees(
        marketFeePercentagePoints
      );

      return feesMonetaryAmount;
    },
    [marketFeePercentagePoints]
  );
};
